<template>
  <Component :is="continuous ? 'div' : BaseCard" :class="containerClasses">
    <p id="candidateSkillsAndAccomplishments"
       class="mb-8 w-64 bg-gradient-to-r bg-clip-text font-bold text-transparent from-bdPurple-600 to-bdOrange-600">
      Skills & Accomplishments.</p>
    <EditableFormDetailedList :icon="TrophyIcon" :allows="candidateSkillsAccomplishments.skills.allows"
                              :list="candidate.skills" :small="small" :editable="editable"
                              @update:list="updateCandidate('skills', $event)" name="Skill"/>
    <div
      v-if="candidate.skills && candidate.skills.length && candidate.accomplishments && candidate.accomplishments.length"
      class="mb-6 h-px border-t border-slate-200"/>
    <EditableFormDetailedList :icon="TrophyIcon"
                              :allows="candidateSkillsAccomplishments.accomplishments.allows"
                              :list="candidate.accomplishments" :small="small" :editable="editable"
                              @update:list="updateCandidate('accomplishments', $event)" name="Accomplishment"/>
    <p v-if="!editable && !candidate.skills?.length && !candidate.accomplishments?.length"
       class="-mt-2 mb-4 text-sm text-slate-400">No skills or accomplishments yet</p>
  </Component>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import EditableFormDetailedList from "./EditableFormDetailedList.vue";
import {TrophyIcon} from "@heroicons/vue/24/outline/index.js";
import {computed} from "vue";
import {candidateSkillsAccomplishments} from "../helpers/ProfileQuestions.js";

const emits = defineEmits(["update:candidate"]);
const props = defineProps({
  candidate: Object,
  continuous: Boolean,
  small: Boolean,
  editable: Boolean,
});

const updateCandidate = (field, value) => {
  if (!props.editable) return;

  const c = {...props.candidate};
  c[field] = value;
  emits("update:candidate", c);
};

const containerClasses = computed(() => {
  const baseClasses = props.continuous ? "px-4 md:px-6 mt-6" : "relative shadow-sm mt-6";
  return baseClasses + (props.small ? " text-sm" : " text-base");
});
</script>
